export default "__VITE_ASSET__7Qicxlk7__"